export function getUserUid() {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('uid');
}

export function getExecutionStepFromPath(path: string) {
  switch (path) {
    case '/finish':
      return 3;
    case '/keywords':
      return 2;
    default:
      return 1;
  }
}

